import React from "react";
import { useParams } from "react-router-dom";
import { useGetLoanBreakdownByLoanRequestIdQuery } from "../../../store/admin/loanRepayment";
import FormalSingleLoanRepaymentBreakdownByMember from "./FormalSingleLoanRepaymentBreakdownByMember";
import InformalSingleLoanRepaymentBreakdownByMember from "./InformalSingleLoanRepaymentBreakdownByMember";

/**
 * Wrapper: resolves loan_model from API and renders Formal or Informal breakdown.
 */
export const SingleLoanRepaymentBreakdownByMember = () => {
  const { loanRequestId } = useParams();
  const { data, isLoading } =
    useGetLoanBreakdownByLoanRequestIdQuery(loanRequestId);

  const loanModel =
    data?.loan_model ?? data?.loan_type?.loan_model ?? "formal";
  const isInformal = loanModel === "informal";

  if (isInformal) {
    return (
      <InformalSingleLoanRepaymentBreakdownByMember
        data={data}
        isLoading={isLoading}
      />
    );
  }

  return (
    <FormalSingleLoanRepaymentBreakdownByMember
      data={data}
      isLoading={isLoading}
    />
  );
};
